import { showSpinner, hideSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { enrollValidation } from './enroll-validation';
import { validateForm, passwordCheck } from '/source/_patterns/01-components/form/form';
import { setMainErrorMessage, moveToNextCheckoutStep, addAddress, removeAddress, loadAddress, focusOnAnyErrors, checkoutPrev, configureAddressFieldInvalidCharsValidator } from '/source/_patterns/01-components/checkout/checkout-shared';
import { IS_ERROR } from '/source/js/base/baseClasses';
import * as checkoutService from '/source/js/services/checkoutService';
import { validCookieId } from '/source/js/utils/validCookie';
import { initToggle, watchToggleStateChanges } from '../checkout/toggle-content';
import { watchConsentTabs, initConsentReadMoreBehavior } from './enroll-consents';
import { handleVIESErrorMessageIfAny } from '../checkout/vat-info';
import { startEnroll, completeEnroll, setGenericData, checkUserName, completeFindAFriend } from '/source/js/gtm/IsaGtmCommerce';
import * as enrollmentService from '/source/js/services/enrollmentService';

const FORM_ENROLLMENT = 'form#enrollment';
const USERNAME = 'username';
const USERNAME_ERROR = 'username-error';
const USERNAME_AVAILABILITY_ERROR = 'username-availability-error';
const USERNAME_ERRORS = 'username|duplicate|invalidword|invalidcharacter|incorrectcharactercount';
const USERNAME_SUCCESS = 'availableusername|available';
const EMAIL = 'email';
const EMAIL_AVAILABILITY_ERROR = 'email-availability-error';
const ENROLLMENT_INFO = '.checkout__enrollment-information, .mod-checkout__enrollment-info';
const REFERRAL_TYPE_REFERRED = 'referred';
const REFERRAL_TYPE_NO_REFERRED = 'assign';

function getUsernameValidationErrorId($usernameInput) {
    return $usernameInput.closest('.checkout-v2').length ? USERNAME_AVAILABILITY_ERROR : USERNAME_ERROR;
}

// jQuery Validate's form-level check clears the text and hides any span.error it finds
// (matching its errorElement/errorClass config), including our username-availability
// error, since it isn't tied to a rule jQuery Validate considers currently invalid.
function captureUsernameAvailabilityErrorText() {
    const $usernameInput = $(`#${USERNAME}`);
    if(!$usernameInput.closest('.checkout-v2').length) return null;
    const $error = $(`#${getUsernameValidationErrorId($usernameInput)}`);
    return $error.length ? $error.text() : null;
}

function restoreUsernameAvailabilityError(previousText) {
    if(previousText === null) return;
    const $usernameInput = $(`#${USERNAME}`);
    const $error = $(`#${getUsernameValidationErrorId($usernameInput)}`);
    if($error.length) {
        $error.text(previousText).show();
    }
    setUsernameValidationIcon($usernameInput, 'error');
}

let melissa = {
    addresses: {},
    enteredAddress: {},
    selectedAddress: {},
    status: undefined,
    sameAddress: false
};

let addressAutocomplete = {
    timeout: null,
    minChars: 3,
    debounceMs: 300,
    suggestions: [],
    selectedIndex: -1,
    isVisible: false
};

export async function setCheckoutEnrollmentSponsorInformation(referralType, sponsorId) {
    try {
        let request = {
            ReferralType: referralType
        };
        if(sponsorId) {
            request.SponsorMemberId = sponsorId;
        }
        await enrollmentService.setEnrollmentSponsor(request);
    } catch (e) {
        console.error(e);
    }
}

function verifySearchOptionShownIsSelected() {
    const $findFriendSection = $('#findFriendSection');

    if($findFriendSection.hasClass('d-none')) {
        return true;
    }

    const $friendsDetails = $('.referred-us-enroll-section .self-enrollment__friends-details');
    const $radios = $friendsDetails.find('input[type="radio"]');
    const $error = $('#referrer-error');

    if($friendsDetails.length && $radios.filter(':checked').length === 0) {
        $error.removeClass('d-none');
        $radios.attr('aria-invalid', 'true').attr('aria-describedby', 'referrer-error');
        $radios.first().focus();
        return false;
    }

    $error.addClass('d-none');
    $radios.removeAttr('aria-invalid aria-describedby');

    return true;
}

async function validateAndSetSponsor() {
    if($('#integrated-referral-form').length && !isIntegratedReferralFormSaved()) {
        try {
            if(!verifySearchOptionShownIsSelected()) return false;
            const distinctValues = Array.from(new Set((Array.isArray(window.heardAboutUsValues) ? window.heardAboutUsValues : []).map(item => item?.Value).filter(Boolean)));
            let otherValue;
            if(window.otherOptionSelectedValue && !distinctValues.includes(window.otherOptionSelectedValue)) {
                otherValue = window.otherOptionSelectedValue;
            }
            const FIND_FRIEND_SECTION_VISIBLE = !$('#findFriendSection').hasClass('d-none');
            const HEARD_ABOUT_US_SECTION_VISIBLE = !$('#heardAboutUs').hasClass('d-none');
            if(HEARD_ABOUT_US_SECTION_VISIBLE) {
                await setCardDetailsToSession(false, null, REFERRAL_TYPE_NO_REFERRED);
                completeFindAFriend('no_referral', distinctValues, otherValue);
            } else if(FIND_FRIEND_SECTION_VISIBLE) {
                const sponsorId = Number($('input[name="referredPerson"]:checked').val()) || 0;
                if(Number.isInteger(sponsorId) && sponsorId > 0) {
                    await setCardDetailsToSession(true, sponsorId, REFERRAL_TYPE_REFERRED);
                    completeFindAFriend('referral');
                } else {
                    await setCardDetailsToSession(false, null, REFERRAL_TYPE_NO_REFERRED);
                    completeFindAFriend('no_referral');
                }
            } else {
                await setCardDetailsToSession(false, null, REFERRAL_TYPE_NO_REFERRED);
                completeFindAFriend('no_referral');
            }
            if($('#integrated-referral-form-saved').length) {
                $('#integrated-referral-form-saved').val('true');
            }
        } catch (error) {
            console.log('validateAndSetSponsor -> error:', error);
            if($('#integrated-referral-form-saved').length) {
                $('#integrated-referral-form-saved').val('false');
            }
        }
    }

    return true;
}

function isIntegratedReferralFormSaved() {
    const FIND_FRIEND_SECTION_VISIBLE = !$('#findFriendSection').hasClass('d-none');
    const HEARD_ABOUT_US_SECTION_VISIBLE = !$('#heardAboutUs').hasClass('d-none');
    if(!HEARD_ABOUT_US_SECTION_VISIBLE && !FIND_FRIEND_SECTION_VISIBLE) {
        return false;
    }
    const el = $('#integrated-referral-form-saved');

    if(el.length === 0) {
        return false;
    }
    let val = el.val();
    return val === 'true';
}

async function setCardDetailsToSession(isreferred, sponsorId, referralType) {
    await setCheckoutEnrollmentSponsorInformation(referralType, sponsorId);
    const request = {
        HowDidYouFindUsMap: window.heardAboutUsValues,
        IsReferred: isreferred,
        CountryCode: $('#integrated-referral-form-country-code').val(),
        MemberId: sponsorId,
        IsOtherOptionSelected: window.isOtherOptionSelected,
        OtherOptionSelectedValue: window.otherOptionSelectedValue
    };

    const isSponsorEmpty = sponsorId === null || sponsorId === undefined || sponsorId === 0;
    const isHeardAboutUsEmpty = (!Array.isArray(window.heardAboutUsValues) || window.heardAboutUsValues.length === 0) && !window.isOtherOptionSelected;
    const FIND_FRIEND_SECTION_VISIBLE = !$('#findFriendSection').hasClass('d-none');
    const HEARD_ABOUT_US_SECTION_VISIBLE = !$('#heardAboutUs').hasClass('d-none');
    if(isSponsorEmpty && isHeardAboutUsEmpty) {
        if(!HEARD_ABOUT_US_SECTION_VISIBLE && !FIND_FRIEND_SECTION_VISIBLE) {
            return;
        }
        if((HEARD_ABOUT_US_SECTION_VISIBLE && $('#integrated-referral-form-noSelected').val() === 'true') ||
            (FIND_FRIEND_SECTION_VISIBLE && $('#integrated-referral-form-yesSelected').val() === 'true')) {
            await checkoutService.setHowDidYouFindUsDetails(request);
        }
    } else {
        await checkoutService.setHowDidYouFindUsDetails(request);
    }
}

let isMelissaAddressEnabledForUser = true;

async function validateEnrollmentForm() {
    const isFindUsCardValid = await validateAndSetSponsor();
    let $element = $(this);
    let $form = $(FORM_ENROLLMENT);
    if(!$form.length) return;

    let invalidCharsMsg = $form.data('msg-invalidchars');
    configureAddressFieldInvalidCharsValidator(invalidCharsMsg);

    let $phone = $('#phone');
    if($phone.val()) {
        let $phonetext = $phone.val().trim();
        $phone.val($phonetext);
    }

    const previousUsernameErrorText = captureUsernameAvailabilityErrorText();
    let enrollmentFormValid = validateForm($form, enrollValidation); //eslint-disable-line
    restoreUsernameAvailabilityError(previousUsernameErrorText);
    if(!enrollmentFormValid) {
        $("label[class*='form-label--checkbox-enrollconsent'] > span.error, label[class*='mod-checkbox--consent'] > span.error").each(function () {
            let parent = $(this).parent().parent();
            let spanClone = $(this).clone();
            $(this).remove();
            spanClone.addClass('consent-error');
            parent.append(spanClone);
        });
    }
    let isPhoneNumberUnique = await uniquePhoneNumberValidator($form);
    let phoneNumberElement = $form[0]['phone'];
    let parent = $(phoneNumberElement).closest('div.form-block, .mod-field');
    if(enrollmentFormValid) {
        $(parent).children('span.error').remove();
        if(!isPhoneNumberUnique) {
            triggerPhoneUniquenessMessage($form);
            return;
        }
    }

    focusOnAnyErrors();
    if(!isFindUsCardValid) return;

    if($(`#${USERNAME}`).closest('.checkout-v2').length && enrollmentFormValid) {
        if(_usernameValidationPromise) {
            await _usernameValidationPromise;
        }
        // Skip re-validation when the username field is disabled (returning to the step) — the value can't have changed.
        const $usernameField = $(`#${USERNAME}`);
        const usernameErrorId = getUsernameValidationErrorId($usernameField);
        if(!$usernameField.is(':disabled') && !$('#username-valid').length && !$(`#${usernameErrorId}`).length && $usernameField.val()) {
            _usernameValidationPromise = handleModernizedUsernameBlur();
            await _usernameValidationPromise;
        }
        if($(`#${usernameErrorId}`).length) {
            focusOnAnyErrors();
            return;
        }
    }

    if(IsSameAddressFieldsAndSelectedAddress() || !isMelissaAddressEnabled()) {
        if(enrollmentFormValid) {
            submitForm($form, $element, submitFailedCallback);
        }
    } else {
        await verifyEnrollmentAddress();
    }
}

function triggerPhoneUniquenessMessage($form) {
    $('#phone-error').remove();
    let phoneNumberElement = $form[0]['phone'];
    let parent = $(phoneNumberElement).closest('div.form-block, .mod-field');
    let msg = $(phoneNumberElement).data('duplicate-phone-number-msg');
    $(phoneNumberElement).attr('aria-invalid', 'true');
    $(phoneNumberElement).attr('aria-describedby', 'phone-error');
    $(phoneNumberElement).attr('data-duplicate-phone', true);
    $(phoneNumberElement).attr('data-is-enrollment', true);
    $(phoneNumberElement).attr('data-prev-phone-number', $form[0]['phone'].value);
    let templateString = `<span id="phone-error" class="error">${msg}</span>`;
    if(parent.hasClass('mod-field')) {
        parent.addClass('mod-field--error');
    } else {
        parent.addClass('is--error');
    }
    $(parent).append(templateString);
    focusOnAnyErrors();
    let grandParent = $(phoneNumberElement).closest('.form-group.form-group--half, .mod-form-group');
    grandParent.addClass('pb-3');
}

function triggerRequestVerificationCodeFailedMessage($form) {
    $('#phone-error').remove();
    let phoneNumberElement = $form[0]['phone'];
    let parent = $(phoneNumberElement).closest('div.form-block, .mod-field');
    let msg = $(phoneNumberElement).data('sms-validation-failed-msg');
    $(phoneNumberElement).attr('aria-invalid', 'true');
    $(phoneNumberElement).attr('aria-describedby', 'phone-error');
    $(phoneNumberElement).attr('data-duplicate-phone', true);
    $(phoneNumberElement).attr('data-is-enrollment', true);
    $(phoneNumberElement).attr('data-prev-phone-number', $form[0]['phone'].value);
    let templateString = `<span id="phone-error" class="error">${msg}</span>`;
    if(parent.hasClass('mod-field')) {
        parent.addClass('mod-field--error');
    } else {
        parent.addClass('is--error');
    }
    $(parent).append(templateString);
    focusOnAnyErrors();
    let grandParent = $(phoneNumberElement).closest('.form-group.form-group--half, .mod-form-group');
    grandParent.addClass('pb-3');
}

async function uniquePhoneNumberValidator($form) {
    const checkbox = document.getElementById('bypassPhoneValidation');
    const isBypassChecked = checkbox ? checkbox.checked : false;
    if(isBypassChecked) {
        return true;
    }
    let phoneNumber;
    let result = false;
    if($form.length > 0) {
        phoneNumber = $form[0]['phone'].value;
        let countryCode = $form[0]['phoneCountryCode'].value;
        if(phoneNumber === undefined) {
            return result;
        } else {
            let request = { PhoneNumber: phoneNumber, MemberId: 0, CountryCode: countryCode };
            result = await checkoutService.checkIfPhoneNumberIsUnique(request);
        }
        return result;
    }
    return result;
}

async function verifyEnrollmentAddress() {
    var result = await checkMelissaAddressVerification();
    if(!result) return;

    // After melissa verification, trigger the parent form submit
    $('.checkout-next').trigger('click');
}

function updateSelectedAddress() {
    let $addressList = $('.melissa-address-list');
    setMelissaVerificationType(2);
    if($addressList.data('selected')) {
        let preSelectedIdx = $addressList.data('preselectedidx');
        if(typeof preSelectedIdx === 'number' && preSelectedIdx >= 0) {
            setMelissaVerificationType(1);
            let address = melissa.addresses[preSelectedIdx];
            melissa.selectedAddress.FirstName = $('#firstName').val();
            melissa.selectedAddress.LastName = $('#lastName').val();
            melissa.selectedAddress.Address1 = address.Address1;
            melissa.selectedAddress.Address2 = address.Address2;
            melissa.selectedAddress.Address3 = address.Address3;
            melissa.selectedAddress.Address4 = address.Address4;
            melissa.selectedAddress.City = address.City;
            melissa.selectedAddress.StateCode = address.StateCode;
            melissa.selectedAddress.ZipCode = address.ZipCode;
        } else {
            updateSelectedAddressWithEnteredAddress();
        }
    } else {
        updateSelectedAddressWithEnteredAddress();
    }
}

function updateFormWithSelectedAddress(address) {
    $('#firstName').val(address.FirstName).trigger('input');
    $('#lastName').val(address.LastName).trigger('input');
    $('#address1Input').val(address.Address1).trigger('input');

    if(address.Address2 && address.Address2.trim() !== '') {
        if($('#address2Input').length === 0 && $('#addAddress').is(':visible')) {
            $('#addAddress').trigger('click');
        }
        if($('#address2Input').length && $('#address2Input').is(':visible')) {
            $('#address2Input').val(address.Address2).trigger('input');
        }
    } else {
        $('#remove2').trigger('click');
    }

    if(address.Address3 && address.Address3.trim() !== '') {
        if($('#address3Input').length === 0 && $('#addAddress').is(':visible')) {
            $('#addAddress').trigger('click');
        }
        if($('#address3Input').length && $('#address3Input').is(':visible')) {
            $('#address3Input').val(address.Address3).trigger('input');
        }
    } else {
        $('#remove3').trigger('click');
    }

    if(address.Address4) {
        $('#address4Input').val(address.Address4).trigger('input');
    }
    $('#cityInput').val(address.City).trigger('input');
    $('#stateInput').val(address.StateCode).trigger('input');
    $('#zipCodeInput').val(address.ZipCode).trigger('input');
    if(address.AddressPhone) {
        $('#phone').val(address.AddressPhone);
    }
}

async function checkMelissaAddressVerification() {
    if(!checkValidationEnrollmentData()) return false;
    if(isMelissaAddressEnabled()) {
        let $addressList = $('.melissa-address-list');
        let selectedAddress = $addressList.data('selected');
        if(!selectedAddress || !melissa.status) {
            var result = await getMelissaAddresses();
            return result;
        } else {
            updateSelectedAddress();
            updateFormWithSelectedAddress(melissa.selectedAddress);
            closeMelissaModal();
        }
    } else {
        setMelissaVerificationType(0);
        updateEnteredAddress();
        updateSelectedAddressWithEnteredAddress();
        closeMelissaModal();
    }
    hideMainErrorMessage();
    return true;
}

function setMelissaVerificationType(id) {
    $('#melissaAddressVerificationType').val(id);
}

function hideMainErrorMessage() {
    $('.checkout-error__msg').addClass('d-none');
    $('.checkout-error__text').text('');
}

function closeMelissaModal() {
    hideMainErrorMessage();
    $('#melissaModal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
}

function updateSelectedAddressWithEnteredAddress() {
    melissa.selectedAddress.FirstName = melissa.enteredAddress.FirstName;
    melissa.selectedAddress.LastName = melissa.enteredAddress.LastName;
    melissa.selectedAddress.Address1 = melissa.enteredAddress.Address1;
    melissa.selectedAddress.Address2 = melissa.enteredAddress.Address2;
    melissa.selectedAddress.Address3 = melissa.enteredAddress.Address3;
    melissa.selectedAddress.Address4 = melissa.enteredAddress.Address4;
    melissa.selectedAddress.City = melissa.enteredAddress.City;
    melissa.selectedAddress.StateCode = melissa.enteredAddress.StateCode;
    melissa.selectedAddress.ZipCode = melissa.enteredAddress.ZipCode;
}

function updateEnteredAddress() {
    melissa.enteredAddress.FirstName = $('#firstName').val();
    melissa.enteredAddress.LastName = $('#lastName').val();
    melissa.enteredAddress.Address1 = $('#address1Input').val();
    melissa.enteredAddress.Address2 = $('#address2Input').val();
    melissa.enteredAddress.Address3 = $('#address3Input').val();
    melissa.enteredAddress.Address4 = $('#address4Input').val();
    melissa.enteredAddress.City = $('#cityInput').val();
    melissa.enteredAddress.StateCode = $('#stateInput').val();
    if(!($('#stateInput').val())) {
        melissa.enteredAddress.StateCode = $('#selectedState').val();
    }
    var zipValue = $('#zipCodeInput').val();
    melissa.enteredAddress.ZipCode = zipValue ? zipValue.replace(/\s+$/, '') : zipValue;
    melissa.enteredAddress.CountryCode = $('#selectedCountry').val();
}

async function getMelissaAddresses() {
    try {
        hideMainErrorMessage();
        showSpinner('verifying address using melissa addresses started');

        let addressObjectForMelissaFetch = GetAddressObjectForMelissa();
        let result = await checkoutService.getMelissaAddress(addressObjectForMelissaFetch);
        updateEnteredAddress();
        updateSelectedAddressWithEnteredAddress();

        if(result && result.IsSuccessful) {
            hideSpinner('address verification completed');
            updateEnteredAddressDefaultSelection(result.EnteredFormattedAddress);
            updateMelissaAddresses(result);
            if(result.SameAddress) {
                return true;
            }
        } else {
            displayMelissaAddressError(result);
            hideSpinner('address verification failed');
        }
        return false;
    } catch (e) {
        console.error(e);
        hideSpinner('address verification failed');
        return false;
    }
}

function GetAddressObjectForMelissa() {
    let statecode = $('#stateInput').val();
    if(!($('#stateInput').val())) {
        statecode = $('#selectedState').val();
    }
    let addressObject = {
        FirstName: $('#firstName').val(),
        LastName: $('#lastName').val(),
        Address1Input: $('#address1Input').val(),
        Address2Input: $('#address2Input').val(),
        Address3Input: $('#address3Input').val(),
        Address4Input: $('#address4Input').val(),
        CityInput: $('#cityInput').val(),
        StateInput: statecode,
        ZipCodeInput: ($('#zipCodeInput').val() || '').replace(/\s+$/, ''),
        CountryCode: $('#selectedCountry').val()
    };
    return addressObject;
}

function displayMelissaAddressError(result) {
    if(result && result.Messages) {
        let responseMsg = result.Messages[0];
        let msg = responseMsg.MessageText;
        melissa.status = responseMsg.Code;
        setMainErrorMessage(msg);
    }
}

function updateMelissaAddresses(data) {
    melissa.sameAddress = data.SameAddress;
    if(data.SameAddress) {
        updateSelectedAddress();
        updateFormWithSelectedAddress(melissa.selectedAddress);
        closeMelissaModal();
        hideMainErrorMessage();
    } else if(data.MelissaAddresses && data.MelissaAddresses.length > 0) {
        let $addressList = $('.melissa-address-list');
        $('.melissa-address-list li:gt(0)').remove();
        melissa.addresses = data.MelissaAddresses;
        addMelissaAddressesToList($addressList);
        $addressList.data('preselectedidx', -1);
        $addressList.data('selected', true);
        melissa.status = 'selected';
        let $addressVerification = $('.isa-modal--address-verification input[name="addressVerification"]');
        $addressVerification.on('input', setSelectedAddress);
        let $firstMelissaOption = $('.isa-modal--address-verification input[name="addressVerification"]:eq(0)');
        $firstMelissaOption.prop('checked', 'checked');
        $firstMelissaOption.trigger('input');
        setMelissaVerificationType(2);
        $('#melissaModal').modal();
    }
}

function setSelectedAddress() {
    let $this = $(this);
    if (!!melissa.addresses) {//eslint-disable-line
        let idx = $this.data('melissaidx');
        let $addressList = $('.melissa-address-list');
        $addressList.data('preselectedidx', idx);
        $addressList.data('selected', true);
    }
}

function addMelissaAddressesToList($addressList) {
    // Detach the entered address (with data-melissaidx="-1") to control ordering
    let $enteredAddressLi = $addressList.find('li[data-melissaidx="-1"]').detach();

    // Append recommended addresses in order from melissa.addresses
    melissa.addresses.forEach(function (item, index) {
        let current = index + 2;
        let addressForDisplay = `${item.FormattedAddress}`;
        let isFirst = index === 0;

        // Create address HTML with new CSS classes - entire structure in one template string
        let addressRow = `
            <li class="melissa-modal-new__address-option">
                <input type="radio" name="addressVerification" id="addr${current}" value="addr${current}" data-melissaidx="${index}" class="form-input form-input--radio">
                <label for="addr${current}" class="form-label form-label--radio melissa-modal-new__address-wrapper">
                    <div class="melissa-modal-new__address-box ${isFirst ? 'melissa-modal-new__address-box--recommended' : ''}">
                        <div class="isa-modal__address melissa-modal-new__address-text" tabindex="0">${addressForDisplay}</div>
                    </div>
                </label>
            </li>`;

        // Append to list in order
        $addressList.append(addressRow);
    });

    // Append entered address at the end and show it
    $addressList.append($enteredAddressLi);
    $enteredAddressLi.show();

    // Show/hide subtitles based on recommended address count
    if(melissa.addresses.length === 1) {
        $('#subtitle-single').show();
        $('#subtitle-multiple').hide();
    } else {
        $('#subtitle-single').hide();
        $('#subtitle-multiple').show();
    }
}

function updateEnteredAddressDefaultSelection(formattedAddress) {
    let $enteredAddress = $('.entered-address');
    let addressForDisplay = `${formattedAddress}`;
    $enteredAddress.html(addressForDisplay);
}

function checkValidationEnrollmentData() {
    let $form = $(FORM_ENROLLMENT);
    return validateForm($form, enrollValidation);
}

function submitFailedCallback(result) {
    if(result && result.Messages) {
        let msg = result.Messages.find(msg => msg.DisplayMessage === true);
        if(!msg) msg = result.Messages[0];
        setSpecificErrorMessage(msg);
        focusOnAnyErrors();
    }
}

function submitSuccessCallback(result) {
    if(result && result.Messages) {
        let msg = result.Messages.find(msg => msg.DisplayMessage === true);
        if(!msg) msg = result.Messages[0];
        let $commerceCode = msg.CommerceCode.toLowerCase();
        let $userNameInput = $(`#${USERNAME}`);
        let usernameErrorId = getUsernameValidationErrorId($userNameInput);
        if(USERNAME_SUCCESS.includes($commerceCode)) {
            let $usernameParent = $userNameInput.parent();
            $usernameParent.removeClass(`${IS_ERROR}`);
            $usernameParent.addClass('valid');
            let availableSpan = `<span id="username-valid" class="valid">${msg.MessageText}</span>`;
            $(`#${usernameErrorId}`).remove();
            $('#username-valid').remove();
            $userNameInput[0].insertAdjacentHTML('afterend', availableSpan);
        }
    }
}

function clearEmailAvailabilityError() {
    const $emailInput = $(`#${EMAIL}`);
    const $availabilityError = $(`#${EMAIL_AVAILABILITY_ERROR}`);
    if(!$availabilityError.length) return;

    $availabilityError.remove();
    const $emailError = $(`#${EMAIL}-error`);
    if($emailError.length) return;

    $emailInput.removeAttr('aria-invalid aria-describedby');
    const $modField = $emailInput.closest('.mod-field');
    if($modField.length) {
        $modField.removeClass('mod-field--error');
    } else {
        $emailInput.parent().removeClass(`${IS_ERROR}`);
    }
}

function setSpecificErrorMessage(msg) {//eslint-disable-line
    if(!msg.CommerceCode) {
        setMainErrorMessage(msg.MessageText);
        return;
    }

    let errorCode = msg.CommerceCode.toLowerCase();

    let $userNameInput = $(`#${USERNAME}`);
    let usernameErrorId = getUsernameValidationErrorId($userNameInput);
    let $emailInput = $(`#${EMAIL}`);

    if(errorCode.includes(EMAIL)) {
        const $modField = $emailInput.closest('.mod-field');
        const $emailParent = $modField.length ? $modField : $emailInput.parent();
        $emailParent.addClass($modField.length ? 'mod-field--error' : IS_ERROR);
        $(`#${EMAIL_AVAILABILITY_ERROR}`).remove();
        $emailInput.attr({
            'aria-invalid': 'true',
            'aria-describedby': EMAIL_AVAILABILITY_ERROR
        });
        let errorSpan = `<span id="${EMAIL_AVAILABILITY_ERROR}" class="error">${msg.MessageText}</span>`;
        $emailInput[0].insertAdjacentHTML('afterend', errorSpan);
        return;
    }
    if(USERNAME_ERRORS.includes(errorCode)) {
        let $usernameParent = $userNameInput.parent();
        $usernameParent.removeClass('valid');
        $usernameParent.addClass(`${IS_ERROR}`);
        let errorSpan = `<span id="${usernameErrorId}" class="error">${msg.MessageText}</span>`;
        $('#username-valid').remove();
        $(`#${usernameErrorId}`).remove();
        $userNameInput[0].insertAdjacentHTML('afterend', errorSpan);
        return;
    }
    setMainErrorMessage(msg.MessageText);
}

async function submitForm($form, $element, failedCallback) {
    try {
        hideMainErrorMessage();
        showSpinner('submitting enrollment form started');

        // Find disabled inputs, and remove the "disabled" attribute
        var disabled = $form.find(':input:disabled').removeAttr('disabled');
        // serialize the form
        var serialized = $form.serialize();
        // re-disabled the set of inputs that you previously enabled
        disabled.attr('disabled', 'disabled');

        let result = await $.ajax({
            type: 'POST',
            url: $element.data('submiturl'),
            data: serialized,
            headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(), CheckoutFlowCookieId: $('input[name="FlowRiderCookieId"]').val() }
        });

        result = validCookieId(result);

        if(result && result.IsSuccessful) {
            hideSpinner('enrollment form submitted successfully');
            completeEnroll();
            moveToNextCheckoutStep(result);
        } else {
            hideSpinner('enrollment form submission failed');
            if(handleVIESErrorMessageIfAny(result)) {
                return;
            }
            if(failedCallback) {
                failedCallback(result);
            }
        }
    } catch (e) {
        console.error(e);
        hideSpinner('enrollment form submission failed');
    }
}

function isMelissaAddressEnabled() {
    if(isMelissaAddressEnabledForUser) {
        let $addressList = $('.melissa-address-list');
        return $addressList.length > 0;
    }
}

function IsSameAddressFieldsAndSelectedAddress() {
    let address2 = $('#address2Input').val() ? $('#address2Input').val() : undefined;
    let address3 = $('#address3Input').val() ? $('#address3Input').val() : undefined;
    let address4 = $('#address4Input').val() ? $('#address4Input').val() : undefined;
    let selectedAddress2 = melissa.selectedAddress.Address2 ? melissa.selectedAddress.Address2 : undefined;
    let selectedAddress3 = melissa.selectedAddress.Address3 ? melissa.selectedAddress.Address3 : undefined;
    let selectedAddress4 = melissa.selectedAddress.Address4 ? melissa.selectedAddress.Address4 : undefined;
    let statecode = $('#stateInput').val();
    if(!($('#stateInput').val())) {
        statecode = $('#selectedState').val();
    }
    var currentZip = $('#zipCodeInput').val();
    var trimmedZip = currentZip ? currentZip.replace(/\s+$/, '') : currentZip;
    if(melissa.selectedAddress &&
        melissa.selectedAddress.FirstName === $('#firstName').val() &&
        melissa.selectedAddress.LastName === $('#lastName').val() &&
        melissa.selectedAddress.Address1 === $('#address1Input').val() &&
        selectedAddress2 === address2 &&
        selectedAddress3 === address3 &&
        selectedAddress4 === address4 &&
        melissa.selectedAddress.City === $('#cityInput').val() &&
        melissa.selectedAddress.StateCode === statecode &&
        melissa.selectedAddress.ZipCode === trimmedZip) {
        return true;
    }
    return false;
}

function resetAddressVerification() {
    let $this = $(this);
    if($this.parents(ENROLLMENT_INFO).length > 0) {
        melissa.status = undefined;
        let $addressList = $('.melissa-address-list');
        $addressList.data('selected', false);
        $addressList.data('preselectedidx', -1);
    }
}
function changePhoneNumberCode() {
    let $option = $('#phoneCountryCode').find('option:selected');
    let $phone = $('#phone');
    $phone.prop('pattern', $option.data('phonenumberregex'));
    formatPhoneNumber();
}

function formatPhoneNumber() {
    const $phone = $('#phone'); // Using jQuery
    let $option = $('#phoneCountryCode').find('option:selected');
    const format = $option.data('phonenumberdisplaypattern');

    // Get current value & remove all non-numeric characters
    const value = $phone.val().replace(/\D/g, '');

    if(!format || $.trim(format) === '') {
        // Update the input value
        $phone.val(value);
        return;
    }

    // Apply formatting based on country pattern
    let formatted = '';
    let valueIndex = 0;

    for (let i = 0; i < format.length && valueIndex < value.length; i++) {
        if(format[i] === '#') {
            formatted += value[valueIndex];
            valueIndex++;
        } else {
            formatted += format[i];
        }
    }

    // Update the input value
    $phone.val(formatted);
}

function resetPhoneErrorState() {
    if($(this).is(':checked')) {
        let phoneField = $('#phone');
        let parent = phoneField.closest('div.form-block, .mod-field');

        // Early return if phone field is not in error state
        if(!parent.hasClass('is--error') && !parent.hasClass('mod-field--error')) {
            return;
        }

        // Remove any error spans
        $('#phone-error').remove();

        // Remove error class
        parent.removeClass('is--error mod-field--error');

        // Reset phone field styling
        phoneField.removeClass('error');
        phoneField.css('border-color', '');
        phoneField.attr('data-duplicate-phone', '');
        phoneField.attr('data-prev-phone-number', '');
    }
}

async function getAddressAutocomplete(searchText) {
    try {
        if(!searchText || searchText.length < addressAutocomplete.minChars) {
            hideAddressAutocomplete();
            return;
        }

        let stateValue = $('#stateInput').val();
        let stateCode = $('#selectedState').val();
        if(stateValue === 'default' || stateCode === 'default') {
            stateValue = '';
            stateCode = '';
        }

        let requestData = {
            CountryCode: $('#selectedCountry').val(),
            Address1: searchText,
            City: $('#cityInput').val(),
            StateInput: stateValue,
            StateCode: stateCode,
            ZipCode: $('#zipCodeInput').val()
        };

        let result = await checkoutService.getMelissaExpressAddressMatches(requestData);

        if(result && result.IsSuccessful && result.MelissaAddresses && result.MelissaAddresses.length > 0) {
            addressAutocomplete.suggestions = result.MelissaAddresses;
            showAddressAutocomplete(result.MelissaAddresses);
        } else {
            hideAddressAutocomplete();
        }
    } catch (e) {
        console.error('Address autocomplete error:', e);
        hideAddressAutocomplete();
    }
}

function showAddressAutocomplete(addresses) {
    try {
        if(!addresses || !Array.isArray(addresses) || addresses.length === 0) {
            hideAddressAutocomplete();
            return;
        }

        let $input = $('#address1Input');
        if(!$input.length) return;

        let $container = $('#address-autocomplete-container');
        $container.attr({ 'role': 'listbox', 'aria-label': 'Address suggestions' });

        $container.empty();
        let searchText = $input.val().trim();

        addresses.forEach((address, index) => {
            if(!address) return;

            let addressParts = [];
            if(address.Address1) addressParts.push(address.Address1);
            if(address.Address2 && address.Address2.trim() !== '') addressParts.push(address.Address2);
            if(address.City) addressParts.push(address.City);
            let stateZip = [];
            if(address.StateCode) stateZip.push(address.StateCode);
            if(address.ZipCode) stateZip.push(address.ZipCode);
            if(stateZip.length > 0) addressParts.push(stateZip.join(' '));
            let displayText = addressParts.join(', ');

            let highlightedText = displayText;
            if(searchText) {
                try {
                    let regex = new RegExp('(' + searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
                    highlightedText = displayText.replace(regex, '<strong>$1</strong>');
                } catch (regexError) {
                    highlightedText = displayText;
                }
            }

            let optionId = 'address-autocomplete-option-' + index;
            let $item = $('<div class="address-autocomplete__item" data-index="' + index + '" id="' + optionId + '" role="option" aria-selected="false" aria-label="' + displayText.replace(/"/g, '&quot;') + '">' + highlightedText + '</div>');
            $item.on('mousedown', function(e) {
                e.preventDefault();
                selectAddressFromAutocomplete(index);
            });
            $container.append($item);
        });

        $container.show();
        $input.attr('aria-expanded', 'true');
        $input.removeAttr('aria-activedescendant');
        addressAutocomplete.isVisible = true;
        addressAutocomplete.selectedIndex = -1;

        // Announce to screen readers
        let count = addresses.length;
        let announceText = count + ' address suggestion' + (count !== 1 ? 's' : '') + ' available. Use up and down arrows to navigate.';
        announceToScreenReader(announceText);
    } catch (e) {
        console.error('Error showing address autocomplete:', e);
        hideAddressAutocomplete();
    }
}

function hideAddressAutocomplete() {
    try {
        $('#address-autocomplete-container').hide();
        let $input = $('#address1Input');
        $input.attr('aria-expanded', 'false');
        $input.removeAttr('aria-activedescendant');
        addressAutocomplete.isVisible = false;
        addressAutocomplete.selectedIndex = -1;
        addressAutocomplete.suggestions = [];
        announceToScreenReader('');
    } catch (e) {
        console.error('Error hiding address autocomplete:', e);
    }
}

function announceToScreenReader(text) {
    let $liveRegion = $('#address-autocomplete-live-region');
    if($liveRegion.length) {
        $liveRegion.text('');
        setTimeout(function() { $liveRegion.text(text); }, 50);
    }
}

function selectAddressFromAutocomplete(index) {
    try {
        if(!addressAutocomplete.suggestions || index < 0 || index >= addressAutocomplete.suggestions.length) {
            hideAddressAutocomplete();
            return;
        }
        let selectedAddress = addressAutocomplete.suggestions[index];
        let announcementText = '';
        if(selectedAddress) {
            populateEnrollFormWithAutocompleteAddress(selectedAddress);

            let parts = [];
            if(selectedAddress.Address1) parts.push(selectedAddress.Address1);
            if(selectedAddress.City) parts.push(selectedAddress.City);
            if(selectedAddress.StateCode) parts.push(selectedAddress.StateCode);
            if(selectedAddress.ZipCode) parts.push(selectedAddress.ZipCode);
            announcementText = 'Selected address: ' + parts.join(', ');
        }
        hideAddressAutocomplete();
        if(announcementText) {
            announceToScreenReader(announcementText);
        }
    } catch (e) {
        console.error('Error selecting address from autocomplete:', e);
        hideAddressAutocomplete();
    }
}

function populateEnrollFormWithAutocompleteAddress(address) {
    try {
        if(!address) return;

        if($('#address1Input').length) {
            $('#address1Input').val(address.Address1 || '').trigger('keyup');
        }

        // If Address2 is returned and not null/empty, ensure address2Input exists by triggering Add Address button if needed
        if(address.Address2 && address.Address2.trim() !== '') {
            if($('#address2Input').length === 0 && $('#addAddress').is(':visible')) {
                $('#addAddress').trigger('click');
            }
            if($('#address2Input').length && $('#address2Input').is(':visible')) {
                $('#address2Input').val(address.Address2).trigger('input').trigger('keyup');
            }
        }

        if(address.Address3 && $('#address3Input').length && $('#address3Input').is(':visible')) {
            $('#address3Input').val(address.Address3).trigger('input').trigger('keyup');
        }

        if(address.Address4 && $('#address4Input').length && $('#address4Input').is(':visible')) {
            $('#address4Input').val(address.Address4).trigger('input').trigger('keyup');
        }

        if($('#cityInput').length) {
            $('#cityInput').val(address.City || '').trigger('input').trigger('keyup');
        }

        if(address.StateCode) {
            if($('#stateInput').length) {
                $('#stateInput').val(address.StateCode).trigger('keyup').trigger('change');
            }
            if($('#selectedState').length) {
                $('#selectedState').val(address.StateCode);
            }
        }

        if($('#zipCodeInput').length) {
            $('#zipCodeInput').val(address.ZipCode || '').trigger('input').trigger('keyup').trigger('blur');
        }

        melissa.status = undefined;
        let $addressList = $('.melissa-address-list');
        $addressList.data('selected', false);
        $addressList.data('preselectedidx', -1);

        $('#address1Input, #address2Input, #address3Input, #address4Input, #cityInput, #zipCodeInput').each(function() {
            if($(this).val()) {
                $(this).siblings('.form-label').addClass('is--active');
                $(this).closest('.mod-field, .form-block').find('.mod-field__label, .form-label').addClass('is--active');
                $(this).addClass('is--active');
            }
        });
    } catch (e) {
        console.error('Error populating form with autocomplete address:', e);
    }
}

function handleAddressAutocompleteKeydown(e) {
    if(!addressAutocomplete.isVisible) return;

    let $items = $('.address-autocomplete__item');
    let maxIndex = $items.length - 1;

    switch (e.keyCode) {
        case 40: // Down arrow
            e.preventDefault();
            addressAutocomplete.selectedIndex = Math.min(addressAutocomplete.selectedIndex + 1, maxIndex);
            updateAutocompleteSelection();
            break;
        case 38: // Up arrow
            e.preventDefault();
            addressAutocomplete.selectedIndex = Math.max(addressAutocomplete.selectedIndex - 1, -1);
            updateAutocompleteSelection();
            break;
        case 13: // Enter
            if(addressAutocomplete.selectedIndex >= 0) {
                e.preventDefault();
                selectAddressFromAutocomplete(addressAutocomplete.selectedIndex);
            }
            break;
        case 27: // Escape
            e.preventDefault();
            hideAddressAutocomplete();
            $('#address1Input').focus();
            break;
        case 9: // Tab - allow natural focus movement, close listbox
            hideAddressAutocomplete();
            break;
    }
}

function updateAutocompleteSelection() {
    let $items = $('.address-autocomplete__item');
    let $input = $('#address1Input');
    $items.removeClass('active').attr('aria-selected', 'false');
    if(addressAutocomplete.selectedIndex >= 0) {
        let $active = $items.eq(addressAutocomplete.selectedIndex);
        $active.addClass('active').attr('aria-selected', 'true');
        $input.attr('aria-activedescendant', $active.attr('id'));

        // Scroll active item into view within the container
        let container = $('#address-autocomplete-container')[0];
        let activeItem = $active[0];
        if(container && activeItem) {
            if(activeItem.offsetTop < container.scrollTop) {
                container.scrollTop = activeItem.offsetTop;
            } else if(activeItem.offsetTop + activeItem.offsetHeight > container.scrollTop + container.clientHeight) {
                container.scrollTop = activeItem.offsetTop + activeItem.offsetHeight - container.clientHeight;
            }
        }

        // Announce the active suggestion
        let label = $active.attr('aria-label') || $active.text();
        let position = addressAutocomplete.selectedIndex + 1;
        let total = $items.length;
        announceToScreenReader(label + ', ' + position + ' of ' + total);
    } else {
        $input.removeAttr('aria-activedescendant');
    }
}

function initAddressAutocomplete() {
    try {
        let $address1Input = $('#address1Input');
        if(!$address1Input.length) return;

        // Set ARIA attributes for combobox pattern
        $address1Input.attr({
            'role': 'combobox',
            'aria-autocomplete': 'list',
            'aria-expanded': 'false',
            'aria-owns': 'address-autocomplete-container',
            'aria-haspopup': 'listbox',
            'autocomplete': 'off'
        });
        $address1Input.removeAttr('aria-activedescendant');

        // Create live region for screen reader announcements if not present
        if(!$('#address-autocomplete-live-region').length) {
            $('body').append('<div id="address-autocomplete-live-region" class="sr-only" aria-live="assertive" aria-atomic="true" role="status"></div>');
        }

        // Pre-create container as a sibling after the input (inside .form-block which has position:relative)
        if(!$('#address-autocomplete-container').length) {
            $address1Input.after('<div id="address-autocomplete-container" class="address-autocomplete" role="listbox" aria-label="Address suggestions"></div>');
        }

        $address1Input.off('input.autocomplete keydown.autocomplete blur.autocomplete');
        $(document).off('click.autocomplete');
        $('#cityInput, #stateInput, #zipCodeInput').off('change.autocomplete');

        $address1Input.on('input.autocomplete', function() {
            try {
                let searchText = $(this).val().trim();
                if(addressAutocomplete.timeout) {
                    clearTimeout(addressAutocomplete.timeout);
                }
                addressAutocomplete.timeout = setTimeout(function() {
                    getAddressAutocomplete(searchText);
                }, addressAutocomplete.debounceMs);
            } catch (e) {
                console.error('Error in address input handler:', e);
            }
        });

        $address1Input.on('keydown.autocomplete', function(e) {
            try {
                handleAddressAutocompleteKeydown(e);
            } catch (err) {
                console.error('Error in keydown handler:', err);
            }
        });

        // Close listbox on blur (delayed to allow mousedown on items)
        $address1Input.on('blur.autocomplete', function() {
            setTimeout(function() {
                if(!$('#address-autocomplete-container').is(':hover')) {
                    hideAddressAutocomplete();
                }
            }, 200);
        });

        $(document).on('click.autocomplete', function(e) {
            try {
                if(!$(e.target).closest('#address1Input, #address-autocomplete-container').length) {
                    hideAddressAutocomplete();
                }
            } catch (err) {
                console.error('Error in click outside handler:', err);
            }
        });

        $('#cityInput, #stateInput, #zipCodeInput').on('change.autocomplete', function() {
            try {
                hideAddressAutocomplete();
            } catch (err) {
                console.error('Error in field change handler:', err);
            }
        });
    } catch (e) {
        console.error('Error initializing address autocomplete:', e);
    }
}

function initVariables() {
    // $checkoutStep = $('.checkout__form-step');
}

function initEventHandlers() {
    let $formInput = $('.form-input, .mod-field__input');
    let $acceptAddressBtn = $('.accept-address-btn');
    let $addAddress = $('#addAddress');
    let $removeInput = $('.form-group__btn--remove');
    let $addressVerification = $('.isa-modal--address-verification input[name="addressVerification"]');
    let $checkoutPrev = $('.checkout-prev');
    let $phonenumber = $('#phoneCountryCode');
    let $phone = $('#phone');
    let $vatInput = $('#vat');
    let $checkValidUsername = $('.btn-check-username');

    $('.checkout-next').on('click', validateEnrollmentForm);
    // $('.checkout__prev-enrollment').on('click', enrollPrev);

    $('#validatePhone').on('click', validatePhone);
    $('#verifyCode').on('click', verifyCode);
    $('#resendCode').on('click', resendCode);
    $('#closeModal').on('click', closeValidationModal);
    $('#bypassPhoneValidation').on('click', resetPhoneErrorState);
    var $otpField = $('#otp-code');
    $otpField.on('input', sanitizeOtpCode);

    $acceptAddressBtn.on('click', verifyEnrollmentAddress);
    $addAddress.on('click', addAddress);
    $removeInput.on('click', removeAddress);
    $addressVerification.on('input', setSelectedAddress);
    $formInput.on('input', resetAddressVerification);
    $checkoutPrev.on('click', checkoutPrev);
    $phonenumber.on('change', changePhoneNumberCode);
    $phone.on('input', formatPhoneNumber);
    $vatInput.on('change', clearVatError);
    $checkValidUsername.on('click', checkValidUsername);

    const $emailInput = $(`#${EMAIL}`);
    if($emailInput.closest('.checkout-v2').length) {
        $emailInput.on('input.emailAvailability', clearEmailAvailabilityError);
        $emailInput.on('focusout.emailAvailability', function() {
            if(!$(this).val()) clearEmailAvailabilityError();
        });
    }

    // Modernized layout: trigger username validation when the value changes
    if($(`#${USERNAME}`).closest('.checkout-v2').length) {
        $(`#${USERNAME}`).on('change', function() { _usernameValidationPromise = handleModernizedUsernameBlur(); });
        // Clear username validation state when user starts typing again
        $(`#${USERNAME}`).on('input', function() {
            $('#username-valid').remove();
            $(`#${getUsernameValidationErrorId($(this))}`).remove();
            $(this).closest('.mod-field__input-wrap').removeClass('valid');
            setUsernameValidationIcon($(this), 'none');
        });
    }

    watchToggleStateChanges();
    passwordCheck();
    loadAddress();
    changePhoneNumberCode();
    initAddressAutocomplete();
    // remove multiple white space between words
    $('#firstName').on('focusout', function (e) {
        var dest = $(this);
        dest.val(jQuery.trim(dest.val()));
        dest.val(dest.val().replace(/[ ]{2,}/, ' '));
    });
    $('#lastName').on('focusout', function (e) {
        var dest = $(this);
        dest.val(jQuery.trim(dest.val()));
        dest.val(dest.val().replace(/[ ]{2,}/, ' '));
    });
    $('#zipCodeInput').on('blur', function (e) {
        var dest = $(this);
        var value = dest.val();
        if(value) {
            dest.val(value.replace(/\s+$/, ''));
        }
    });
    addGtmTagForStartEnroll();
}

function addGtmTagForStartEnroll() {
    if(
        window.ga_props.length > 0 &&
        window.ga_props[0]
    ) {
        const catalog = window.ga_props[0].CatalogName || '';
        const memberId = window.ga_props[0].MemberId || '';
        const memberType = window.ga_props[0].MemberType || '';
        const cultureCode = window.ga_props[0].CultureCode || '';
        var preferredCultureCode = window.ga_props[0].PreferredCultureCode || '';

        setGenericData(catalog, memberType, memberId, cultureCode, preferredCultureCode);
        startEnroll();
    } else {
        console.warn('ga_props is not available or malformed');
    }
}

function clearVatError() {
    const $vatInput = $('#vat');
    if($vatInput.val() === '') {
        if($vatInput.closest('.checkout-v2').length) {
            $vatInput.removeAttr('aria-invalid');
            $('#vat-error').hide();
        } else {
            $('#vat-error-container').addClass('d-none').removeClass('is--error');
            $('#vat-error-msg').hide();
        }
        $('.vatField').removeClass('mod-field--error');
    }
}

async function checkValidUsername(e) {
    e.preventDefault();
    let $userNameInput = $(`#${USERNAME}`);
    let usernameErrorId = getUsernameValidationErrorId($userNameInput);
    if(!$userNameInput.val()) {
        $('#username-valid').remove();
        $userNameInput.parent().addClass(`${IS_ERROR}`);
        var requiredMsg = $userNameInput.attr('data-msg-required');
        let errorSpan = `<span id="${usernameErrorId}" class="error">${requiredMsg}</span>`;
        $userNameInput[0].insertAdjacentHTML('afterend', errorSpan);
        return;
    }
    showSpinner('checking username availability started');

    let request = { UserName: $userNameInput.val() };
    var result = await checkoutService.ValidUsername(request);
    hideSpinner('username availability check completed');
    if(result && result.IsSuccessful) {
        submitSuccessCallback(result.ResponseModel);
        checkUserName($userNameInput.val(), 'available');
    } else {
        submitFailedCallback(result.ResponseModel);
        const hasDuplicateCode = Array.isArray(result.ResponseModel.Messages) &&
            result.ResponseModel.Messages.some(msg => msg && msg.CommerceCode === 'Duplicate');

        if(hasDuplicateCode) {
            checkUserName($userNameInput.val(), 'unavailable');
        } else {
            checkUserName($userNameInput.val(), 'error');
        }
    }
}

function setUsernameValidationIcon($userNameInput, state) {
    const $icon = $userNameInput.siblings('.mod-field__icon--validation');
    if(state === 'success') {
        $icon.html('<i class="fal fa-circle-check"></i>').removeClass('d-none');
        $userNameInput.closest('.mod-field').removeClass('mod-field--error').addClass('mod-field--success');
    } else if(state === 'error') {
        $icon.html('<i class="fal fa-circle-exclamation"></i>').removeClass('d-none');
        $userNameInput.closest('.mod-field').removeClass('mod-field--success').addClass('mod-field--error');
    } else {
        $icon.empty().addClass('d-none');
        $userNameInput.closest('.mod-field').removeClass('mod-field--error mod-field--success');
    }
}

// Sequence counter — only the result from the latest blur call is applied.
let _usernameValidationSeq = 0;
let _usernameValidationPromise = null;

// Runs on blur of the username field in the modernized layout only (checkout-v2).
// Validates in priority order: frontend (required, invalid chars) → restricted words → availability.
async function handleModernizedUsernameBlur() {
    const $userNameInput = $(`#${USERNAME}`);
    const usernameErrorId = getUsernameValidationErrorId($userNameInput);
    // A disabled username field can't have been modified, so skip API validation and status rendering.
    if($userNameInput.is(':disabled')) return;
    const seq = ++_usernameValidationSeq;
    const $inputWrap = $userNameInput.closest('.mod-field__input-wrap');
    const val = $userNameInput.val();
    const hasExistingError = $(`#${usernameErrorId}`).length > 0;

    $('#username-valid').remove();
    if(!hasExistingError) {
        $inputWrap.removeClass('valid');
        setUsernameValidationIcon($userNameInput, 'none');
    }

    // Priority 1 – required
    if(!val) {
        setUsernameValidationIcon($userNameInput, 'error');
        const requiredMsg = $userNameInput.attr('data-msg-required');
        $(`#${usernameErrorId}`).remove();
        $userNameInput[0].insertAdjacentHTML('afterend', `<span id="${usernameErrorId}" class="error">${requiredMsg}</span>`);
        return;
    }

    showSpinner('checking username availability started');
    const request = {
        UserName: val,
        CountryCode: $('#selectedCountry').val()
    };
    const result = await checkoutService.ValidUsername(request);
    hideSpinner('username availability check completed');

    // Discard result if a newer blur call has already started
    if(seq !== _usernameValidationSeq) return;

    // Replace the previous result only after the latest request has completed.
    $('#username-valid').remove();

    if(result && result.IsSuccessful) {
        if(result.ResponseModel && result.ResponseModel.Messages) {
            const msg = result.ResponseModel.Messages.find(m => m.DisplayMessage === true) || result.ResponseModel.Messages[0];
            if(msg) {
                $(`#${usernameErrorId}`).remove();
                setUsernameValidationIcon($userNameInput, 'success');
                $inputWrap.addClass('valid');
                $userNameInput[0].insertAdjacentHTML('afterend', `<span id="username-valid" class="valid">${msg.MessageText}</span>`);
                checkUserName(val, 'available');
            }
        }
    } else {
        if(result && result.ResponseModel && result.ResponseModel.Messages) {
            const msg = result.ResponseModel.Messages.find(m => m.DisplayMessage === true) || result.ResponseModel.Messages[0];
            if(msg) {
                $(`#${usernameErrorId}`).remove();
                setUsernameValidationIcon($userNameInput, 'error');
                $userNameInput[0].insertAdjacentHTML('afterend', `<span id="${usernameErrorId}" class="error">${msg.MessageText}</span>`);
                const hasDuplicateCode = result.ResponseModel.Messages.some(m => m && m.CommerceCode === 'Duplicate');
                checkUserName(val, hasDuplicateCode ? 'unavailable' : 'error');
            }
        }
    }
}

function sanitizeOtpCode() {
    var $otpField = $('#otp-code');
    var $verifyButton = $('#verifyCode');

    var sanitizedValue = $otpField.val().replace(/[^0-9]/g, '');
    $otpField.val(sanitizedValue);

    if($otpField.val().length > 4) {
        var slicedValue = $otpField.val().slice(0, 4);
        $otpField.val(slicedValue);
    }
    if($otpField.val().trim().length >= 4) {
        $verifyButton.removeAttr('disabled');
    } else {
        $verifyButton.attr('disabled', 'disabled');
    }
}

async function validatePhone() {
    showSpinner('validating phone number started');
    let $form = $(FORM_ENROLLMENT);
    let isPhoneNumberUnique = await uniquePhoneNumberValidator($form);
    if(!isPhoneNumberUnique) {
        triggerPhoneUniquenessMessage($form);
        hideSpinner('phone validation completed');
        return;
    }
    let $phone = $('#phone');
    let phoneCountryCode = $('#phoneCountryCode');
    let selectedOption = phoneCountryCode.find('option:selected');
    let countryCode = selectedOption.attr('data-phonenumbercode');
    let request = { PhoneNumber: $phone.val(), CountryCode: countryCode };
    var result = await checkoutService.validatePhone(request);
    hideSpinner('phone validation completed');
    if(result === true) {
        resetValidationModal();
        $('.validatePhoneModel').click();
        sanitizeOtpCode();
    } else {
        triggerRequestVerificationCodeFailedMessage($form);
    }
}

async function verifyCode() {
    showSpinner('verifying one time code started');
    let $phone = $('#phone');
    let $otp = $('#otp-code');
    let $verificationMessage = $('#verificationMessage');
    let phoneCountryCode = $('#phoneCountryCode');
    let selectedOption = phoneCountryCode.find('option:selected');
    let countryCode = selectedOption.attr('data-phonenumbercode');
    let request = { PhoneNumberToVerify: $phone.val(), CountryCode: countryCode, Code: $otp.val() };
    var result = await checkoutService.verifyCode(request);
    $verificationMessage.html(result.ValidationMessage);
    $verificationMessage.show();
    if(result.AttemptsExhausted || result.IsValidated) {
        showHideSMSValidationButtons(true);
        $('#phone').attr('disabled', 'disabled');
        $('#validatePhone').attr('disabled', 'disabled');
        $('#phoneCountryCode').attr('disabled', 'disabled');
    }
    if(result.IsValidated) {
        $('#loading-announcer').text('code validated');
        $('#phoneValidatedStatus').val(true);
    }
    if(result.AttemptsExhausted) {
        $('#loading-announcer').text('attempts exhausted');
        $('#phoneValidationAttemptsStatus').val(true);
    }
    if(!result.IsValidated) { $verificationMessage.addClass('validation-error'); }
    hideSpinner('code verification completed');
}

async function resendCode() {
    showSpinner('resending verification code started');
    resetValidationModal();
    sanitizeOtpCode();
    let $phone = $('#phone');
    let phoneCountryCode = $('#phoneCountryCode');
    let selectedOption = phoneCountryCode.find('option:selected');
    let countryCode = selectedOption.attr('data-phonenumbercode');
    let request = { PhoneNumber: $phone.val(), CountryCode: countryCode };
    var result = await checkoutService.validatePhone(request);
    if(result === true) {
        var message = $('#codeResentMessage').html();
        $('#verificationMessage').html(message);
        $('#verificationMessage').show();
    } else {
        var errorMessage = $('#errorMessage').html();
        $('#verificationMessage').html(errorMessage);
        $('#verificationMessage').addClass('validation-error');
        $('#verificationMessage').show();
    }
    hideSpinner('Code resent');
}

function resetValidationModal() {
    $('#verificationMessage').hide();
    $('#verificationMessage').html('');
    $('#verificationMessage').removeClass('validation-error');
    $('#otp-code').val('');
    showHideSMSValidationButtons(false);
}

function showHideSMSValidationButtons(hide) {
    if(hide === true) {
        $('#verifyCode').hide();
        $('#resendCode').hide();
        $('#closeModal').show();
    } else {
        $('#verifyCode').show();
        $('#resendCode').show();
        $('#closeModal').hide();
    }
}

function closeValidationModal() {
    $('#validatePhoneModel').modal('hide');
}

function setToggleSwitchWidth($switch) {
    try {
        if($switch.length === 0) return;
        const $onSpan = $switch.find('.toggle-checkbox-on');
        const $offSpan = $switch.find('.toggle-checkbox-off');
        let onSwitchHadHiddenClass = false;
        if($onSpan.hasClass('hideSwitch')) {
            onSwitchHadHiddenClass = true;
        }
        $onSpan.css('width', '');
        $offSpan.css('width', '');
        $onSpan.removeClass('hideSwitch');
        $offSpan.removeClass('hideSwitch');

        const onWidth = $onSpan.width();
        const offWidth = $offSpan.width();
        const maxWidth = Math.max(onWidth, offWidth) + 4;
        $onSpan.width(maxWidth);
        $offSpan.width(maxWidth);
        if(onSwitchHadHiddenClass) {
            $onSpan.addClass('hideSwitch');
        } else {
            $offSpan.addClass('hideSwitch');
        }
    } catch (error) {
        console.log('error:', error);
    }
}

$(function () {
    if($('#bpc-toggle-switch-button').length) {
        setToggleSwitchWidth($('#bpc-toggle-switch-button'));
    }
    if($('#es-toggle-switch-button').length) {
        setToggleSwitchWidth($('#es-toggle-switch-button'));
    }
    if($('.checkout__form-step--enrollment, .mod-checkout__step--enrollment').length < 1) return;

    initVariables();
    initEventHandlers();
    initToggle();
    watchConsentTabs();
    initConsentReadMoreBehavior();
});
